"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var i0 = require("@angular/core");
var i1 = require("./ticket-datetime-cell.component");
var styles_TicketGridDatetimeCell = [];
var RenderType_TicketGridDatetimeCell = i0.ɵcrt({ encapsulation: 2, styles: styles_TicketGridDatetimeCell, data: {} });
exports.RenderType_TicketGridDatetimeCell = RenderType_TicketGridDatetimeCell;
function View_TicketGridDatetimeCell_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵted(0, null, ["", ""]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = ((_co.params == null) ? null : _co.params.value); _ck(_v, 0, 0, currVal_0); }); }
exports.View_TicketGridDatetimeCell_0 = View_TicketGridDatetimeCell_0;
function View_TicketGridDatetimeCell_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "ticket-grid-datetime-cell", [], null, null, null, View_TicketGridDatetimeCell_0, RenderType_TicketGridDatetimeCell)), i0.ɵdid(1, 49152, null, 0, i1.TicketGridDatetimeCell, [], null, null)], null, null); }
exports.View_TicketGridDatetimeCell_Host_0 = View_TicketGridDatetimeCell_Host_0;
var TicketGridDatetimeCellNgFactory = i0.ɵccf("ticket-grid-datetime-cell", i1.TicketGridDatetimeCell, View_TicketGridDatetimeCell_Host_0, {}, {}, []);
exports.TicketGridDatetimeCellNgFactory = TicketGridDatetimeCellNgFactory;
